import styled from 'vue-styled-components'

export default styled.div`
.vehicle-types-content {
  background-color: #FFFFFF;
  border-radius: 5px;
  border: 1px solid #cccccc;
  display: block;
  margin: 0 auto;
  & .vehicle-types-header{
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #cccccc;
  }
  & .col {
      text-align: center;
      padding: 15px;
      &.vt-title {
        display: flex;
        justify-content: flex-start;
        text-align: left;
        & .con-slot-label{
          font-weight: bold;
        }
      }
      &.check {
        width: 20px;
        max-width: 20px;
      }
  }
  & .vehicle-types-body {
    & .item {
      display: flex;
      flex-direction: row;
      &:hover{
        background-color: #efefef;
        cursor: pointer;
      }
    }
  }
}
.btn-save {
  display: flex;
  margin: 0 auto;
  width: 30%;
  justify-content: center;
}
.label {
  font-size: 1em;
}
.header-modal {
  background-color: #2962ff;
}
.modal-button-custom {
  padding: 5px;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  margin-top: 25px;
}
.button-group {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1.5em;
}
.buttons .button:not(:last-child):not(.is-fullwidth) {
  margin-right: 0.1rem !important;
}
.notices {
  z-index: 1000000000000000000 !important;
}
`;